import { styled as styledMUI, Typography } from '@mui/material';
import styled from 'styled-components';
import { Ellipsis } from '../../../../../style';

export const ElementClass = styledMUI(Typography)(({ theme }) => ({
    minHeight: '40px',
    color: theme.color.black.main,
    fontSize: theme.font.size.small,
    fontWeight: 'bold',
    gridRow: 1,
    display: 'flex',
    alignItems: 'center',
}));

export const ElementData = styledMUI(ElementClass)(({ color }) => ({
    fontWeight: 'normal',
    color,
}));

export const Name = styled(Ellipsis).attrs({
    width: '100%',
})`
    font-size: ${({ theme }) => theme.font.size.smaller};
    color: ${({ theme }) => theme.color.black.main};
`;
